import { render } from "./NewFeatureTour.vue?vue&type=template&id=7c8b25a0"
import script from "./NewFeatureTour.vue?vue&type=script&lang=js"
export * from "./NewFeatureTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Employ/Onboarding/Modal/NewFeatureTour.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c8b25a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c8b25a0', __exports__)) {
    api.reload('7c8b25a0', __exports__)
  }
  
  module.hot.accept("./NewFeatureTour.vue?vue&type=template&id=7c8b25a0", () => {
    api.rerender('7c8b25a0', render)
  })

}


export default __exports__